/**
 * Enum of status fields related to testing, training and medical clearance.
 */
export enum StatusField {
  ClearanceExpiration = 'clearanceExpiration',
  TestDueDate = 'testDueDate',
  TrainingExpiration = 'trainingExpiration'
}
